import httpClient from "@/plugins/axios";

export const getTags = async (query = '') => {
    const params = {};
    if (query) {
        params['search'] = query;
    }
    const response = await httpClient.get(`/admin/v1/tags/`, {
        params: params
    });
    return response;
}

export const getTag = async (tagId) => {
    const response = await httpClient.get(`/admin/v1/tags/${tagId}/`);
    return response;
}

export const createTag = async (tagData) => {
    const response = await httpClient.post('/admin/v1/tags/', tagData);
    return response;
}

export const updateTag = async (tagId, tagData) => {
    const response = await httpClient.put(`/admin/v1/tags/${tagId}/`, tagData);
    return response;
}

export const deleteTag = async (tagId) => {
    const response = await httpClient.delete(`/admin/v1/tags/${tagId}/`);
    return response;
}

export const getNewsTags = async (newsId) => {
    const response = await httpClient.get(`/admin/v1/news/${newsId}/tags/`);
    return response;
}

export const updateTagsSettings = async (tagsEnabled) => {
    const response = await httpClient.put('/admin/v1/tenant/tags-settings/', {
        tags_enabled: tagsEnabled
    });
    return response;
}
